export const GET_DROPDOWN = 'CONSIGNMENT_ADD: GET_DROPDOWN';
export const GET_DROPDOWN_SUCCESS = 'CONSIGNMENT_ADD: GET_DROPDOWN_SUCCESS';
export const GET_DROPDOWN_FAILURE = 'CONSIGNMENT_ADD: GET_DROPDOWN_FAILURE';
export const GET_PRODUCTS = 'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCTS';
export const GET_PRODUCTS_SUCCESS =
    'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILURE =
    'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCTS_FAILURE';
export const GET_PRODUCTS_BULK = 'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCTS_BULK';
export const GET_PRODUCTS_BULK_SUCCESS =
    'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCTS_BULK_SUCCESS';
export const GET_PRODUCTS_BULK_FAILURE =
    'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCTS_BULK_FAILURE';
export const SET_PRODUCTS = 'CONSIGNMENT_ADDPRODUCTS:SET_PRODUCTS';
export const CLEAR_PRODUCTS = 'CONSIGNMENT_ADDPRODUCTS:CLEAR_PRODUCTS';
export const VALIDATE_PRODUCTS = 'CONSIGNMENT_ADDPRODUCTS:VALIDATE_PRODUCTS';
export const VALIDATE_PRODUCTS_SUCCESS =
    'CONSIGNMENT_ADDPRODUCTS:VALIDATE_PRODUCTS_SUCCESS';
export const VALIDATE_PRODUCTS_FAILURE =
    'CONSIGNMENT_ADDPRODUCTS: VALIDATE_PRODUCTS_FAILURE';
export const CLEAR_VALIDATED_PRODUCTS =
    'CONSIGNMENT_ADDPRODUCTS: CLEAR_VALIDATED_PRODUCTS';
export const SET_PROGRESS_BAR_STATUS =
    'CONSIGNMENT_ADDPROGRESSBAR: SET_PROGRESS_BAR_STATUS';
export const SET_SURGERY_NUMBER =
    'CONSIGNMENT_ADDPROGRESSBAR: SET_SURGERY_NUMBER';
export const RESET_PROGRESS_BAR_STATUS =
    'CONSIGNMENT_ADDPROGRESSBAR: RESET_PROGRESS_BAR_STATUS';
export const SET_PROGRESS_BAR_CURRENT_STEP =
    'CONSIGNMENT_ADDPROGRESSBAR: SET_PROGRESS_BAR_CURRENT_STEP';
export const SET_PROGRESS_BAR_EDIT_MODE =
    'CONSIGNMENT_ADDPROGRESSBAR: SET_PROGRESS_BAR_EDIT_MODE';
//product details

export const GET_PRODUCT_DETAILS =
    'CONSIGNMENT_ADDPRODUCTS: GET_PRODUCT_DETAILS';
export const GET_PRODUCT_DETAILS_SUCCESS =
    'CONSIGNMENT_ADDPRODUCTS: GET_PRODUCT_DETAILS_SUCCESS';
export const GET_PRODUCT_DETAILS_ERROR =
    'CONSIGNMENT_ADDPRODUCTS: GET_PRODUCT_DETAILS_ERROR';
export const SORT_PRODUCT_DETAILS =
    'CONSIGNMENT_ADDPRODUCTS: SORT_PRODUCT_DETAILS';

export const GET_CONSIGNMENT_ADD_DETAILS =
    'CONSIGNMENT_ADD: GET_CONSIGNMENT_ADD_DETAILS';
export const GET_CONSIGNMENT_ADD_DETAILS_SUCCESS =
    'CONSIGNMENT_ADD: GET_CONSIGNMENT_ADD_DETAILS_SUCCESS';
export const GET_CONSIGNMENT_ADD_DETAILS_FAILURE =
    'CONSIGNMENT_ADD: GET_CONSIGNMENT_ADD_DETAILS_FAILURE';

export const GET_CONSIGNMENT_ADD_MYCASEREF =
    'CONSIGNMENT_ADD: GET_CONSIGNMENT_ADD_MYCASEREF';
export const GET_CONSIGNMENT_ADD_MYCASEREF_SUCCESS =
    'CONSIGNMENT_ADD: GET_CONSIGNMENT_ADD_MYCASEREF_SUCCESS';
export const GET_CONSIGNMENT_ADD_MYCASEREF_FAILURE =
    'CONSIGNMENT_ADD: GET_CONSIGNMENT_ADD_MYCASEREF_FAILURE';

export const SAVE_CONSIGNMENT_ADD_DETAILS =
    'CONSIGNMENT_ADD: SAVE_CONSIGNMENT_ADD_DETAILS';
export const SAVE_CONSIGNMENT_ADD_DETAILS_SUCCESS =
    'CONSIGNMENT_ADD: SAVE_CONSIGNMENT_ADD_DETAILS_SUCCESS';
export const SAVE_CONSIGNMENT_ADD_DETAILS_FAILURE =
    'CONSIGNMENT_ADD: SAVE_CONSIGNMENT_ADD_DETAILS_FAILURE';
export const UPDATE_CONSIGNMENT_ADD_DETAILS =
    'CONSIGNMENT_ADD: UPDATE_CONSIGNMENT_ADD_DETAILS';
export const UPDATE_CONSIGNMENT_ADD_DETAILS_SUCCESS =
    'CONSIGNMENT_ADD: UPDATE_CONSIGNMENT_ADD_DETAILS_SUCCESS';
export const UPDATE_CONSIGNMENT_ADD_DETAILS_FAILURE =
    'CONSIGNMENT_ADD: UPDATE_CONSIGNMENT_ADD_DETAILS_FAILURE';
export const VALIDATE_ACCOUNT = 'VALIDATE_ACCOUNT';
export const VALIDATE_ACCOUNT_SUCCESS =
    'VALIDATE_ACCOUNT_SUCCESS';
export const VALIDATE_ACCOUNT_FAILURE =
    'VALIDATE_ACCOUNT_FAILURE';

export const SET_PRODUCTSGUIDE =
    'CONSIGNMENT_ADDPRODUCTSGUIDE:SET_PRODUCTSGUIDE';

export const GET_PRODUCTSGUIDE =
    'CONSIGNMENT_ADDPRODUCTSGUIDE:GET_PRODUCTSGUIDE';
export const GET_PRODUCTSGUIDE_SUCCESS =
    'CONSIGNMENT_ADDPRODUCTSGUIDE:GET_PRODUCTSGUIDE_SUCCESS';
export const GET_PRODUCTSGUIDE_FAILURE =
    'CONSIGNMENT_ADDPRODUCTSGUIDE:GET_PRODUCTSGUIDE_FAILURE';

//category data
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA =
    'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCT_BRAND_AND_CATEGORY_DATA';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS =
    'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCT_BRAND_AND_CATEGORY_DATA_SUCCESS';
export const GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE =
    'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCT_BRAND_AND_CATEGORY_DATA_FAILURE';

//approach and technology
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY =
    'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS =
    'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS';
export const GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE =
    'CONSIGNMENT_ADDPRODUCTS:GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE';

export const CLEAR_PRODUCTS_GUIDE =
    'CONSIGNMENT_ADDPRODUCTSGUIDE:CLEAR_PRODUCTS_GUIDE';
export const UPDATE_CART_DATA = 'CONSIGNMENT_ADD: UPDATE_CART_QUANTITY';
export const UPDATE_CART_PRODUCTS_QUANTITY =
    'CONSIGNMENT_ADD: UPDATE_CART_PRODUCTS_QUANTITY';
export const CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT =
    'CONSIGNMENT_ADD:CHANGE_SHIPPING_ACKNOWLEGMENT_CHECKOUT';
export const SET_CART_DATA = 'CONSIGNMENT_ADD: SET_CART_DATA';
export const SET_CART_DATA_PRICE_OVERRIDE =
    'CONSIGNMENT_ADD: SET_CART_DATA_PRICE_OVERRIDE';
export const UPDATE_CART_DATA_PRICEOVERRIDE =
    'CONSIGNMENT_ADD: UPDATE_CART_DATA_PRICEOVERRIDE';
//Product Templates

export const SET_EXPANDED_FILTER_VIEW =
    'CONSIGNMENT_ADD: SET_EXPANDED_FILTER_VIEW';
export const SET_PRODUCTSTEMPLATESFILTER =
    'CONSIGNMENT_ADDPRODUCTSTEMPLATESFILTER:SET_PRODUCTSTEMPLATESFILTER';

export const GET_PRODUCTSTEMPLATESFILTER =
    'CONSIGNMENT_ADDPRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER';
export const GET_PRODUCTSTEMPLATESFILTER_SUCCESS =
    'CONSIGNMENT_ADDPRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_SUCCESS';
export const GET_PRODUCTSTEMPLATESFILTER_FAILURE =
    'CONSIGNMENT_ADDPRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_FAILURE';

//Update Template filter refine data (listing)
export const SET_PRODUCT_TEMPLATE_REFINE_DATA =
    'CONSIGNMENT_ADD: SET_PRODUCT_TEMPLATE_REFINE_DATA';
export const SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST =
    'CONSIGNMENT_ADD: SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST';

//get detailed templates list
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST =
    'CONSIGNMENT_ADD: GET_DETAILED_PRODUCT_TEMPLATE_LIST';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS =
    'CONSIGNMENT_ADD: GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE =
    'CONSIGNMENT_ADD: GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE';

//create template
export const CREATE_PRODUCT_TEMPLATE =
    'CONSIGNMENT_ADD: CREATE_PRODUCT_TEMPLATE';
export const CREATE_PRODUCT_TEMPLATE_SUCCESS =
    'CONSIGNMENT_ADD: CREATE_PRODUCT_TEMPLATE_SUCCESS';
export const CREATE_PRODUCT_TEMPLATE_FAILURE =
    'CONSIGNMENT_ADD: CREATE_PRODUCT_TEMPLATE_FAILURE';

export const RESET_CREATE_TEMPLATE = 'CONSIGNMENT_ADD: RESET_CREATE_TEMPLATE';

//update product template
export const UPDATE_PRODUCT_TEMPLATE =
    'CONSIGNMENT_ADD: UPDATE_PRODUCT_TEMPLATE';
export const UPDATE_PRODUCT_TEMPLATE_SUCCESS =
    'CONSIGNMENT_ADD: UPDATE_PRODUCT_TEMPLATE_SUCCESS';
export const UPDATE_PRODUCT_TEMPLATE_FAILURE =
    'CONSIGNMENT_ADD: UPDATE_PRODUCT_TEMPLATE_FAILURE';

//get template details with template id
export const GET_TEMPLATE_DETAILS = 'CONSIGNMENT_ADD: GET_TEMPLATE_DETAILS';
export const GET_TEMPLATE_DETAILS_SUCCESS =
    'CONSIGNMENT_ADD: GET_TEMPLATE_DETAILS_SUCCESS';
export const GET_TEMPLATE_DETAILS_FAILURE =
    'CONSIGNMENT_ADD: GET_TEMPLATE_DETAILS_FAILURE';

export const GET_DATA_FOR_PRODUCT_TEMPLATE =
    'CONSIGNMENT_ADD: GET_DATA_FOR_PRODUCT_TEMPLATE';
export const GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS =
    'CONSIGNMENT_ADD: GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS';
export const GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE =
    'CONSIGNMENT_ADD: GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE';
export const UPDATE_PRODUCT_TEMPLATE_LIST =
    'CONSIGNMENT_ADD: UPDATE_PRODUCT_TEMPLATE_LIST';

export const STORE_CONSIGNMENT_ADD_DETAILS =
    'CONSIGNMENT_ADD: STORE_CONSIGNMENT_ADD_DETAILS';
export const RESOURCE_TYPE = 'KB';
export const RESET_CART_DATA = 'CONSIGNMENT_ADD: RESET_CART_DATA';
export const GET_PRODUCTS_PRICE = 'CONSIGNMENT_ADD: GET_PRODUCTS_PRICE';
export const GET_PRICES_FOR_ITEMS = 'CONSIGNMENT_ADD: GET_PRICES_FOR_ITEMS';
export const GET_PRICES_FOR_ITEMS_SUCCESS =
    'CONSIGNMENT_ADD: GET_PRICES_FOR_ITEMS_SUCCESS';
export const GET_PRICES_FOR_ITEMS_FAILURE =
    'CONSIGNMENT_ADD: GET_PRICES_FOR_ITEMS_FAILURE';

export const STORE_ITEM_TABLE_DATA = 'CONSIGNMENT_ADD: STORE_ITEM_TABLE_DATA';
export const STORE_ITEM_TABLE_DATA_SUCCESS =
    'CONSIGNMENT_ADD: STORE_ITEM_TABLE_DATA_SUCCESS';
export const STORE_ITEM_TABLE_DATA_FALURE =
    'CONSIGNMENT_ADD: STORE_ITEM_TABLE_DATA_FAILURE';

// add po image
export const CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD =
    'CONSIGNMENT_ADD: USAGE_ATTACHMENT_UPLOAD';
export const CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_FAILURE =
    'CONSIGNMENT_ADD: USAGE_ATTACHMENT_UPLOAD_FAILURE';
export const CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE =
    'CONSIGNMENT_ADD: USAGE_ATTACHMENT_UPLOAD_SUCCESS_TISSUE';
export const CONSIGNMENT_ADD_USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE =
    'CONSIGNMENT_ADD: USAGE_ATTACHMENT_UPLOAD_SUCCESS_NONTISSUE';
export const CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST =
    'CONSIGNMENT_ADD: DELETE_ATTACHMENT_REQUEST';
export const CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST_SUCCESS =
    'CONSIGNMENT_ADD: DELETE_ATTACHMENT_REQUEST_SUCCESS';
export const CONSIGNMENT_ADD_DELETE_ATTACHMENT_REQUEST_FAILURE =
    'CONSIGNMENT_ADD: DELETE_ATTACHMENT_REQUEST_FAILURE';
export const CONSIGNMENT_ADD_RESET_PO_ATTACHMENT =
    'CONSIGNMENT_ADD: RESET_PO_ATTACHMENT';
export const CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW =
    'CONSIGNMENT_ADD: GET_IMAGE_PO_PREVIEW';
export const CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW_SUCCESS =
    'CONSIGNMENT_ADD: GET_IMAGE_PO_PREVIEW_SUCCESS';
export const CONSIGNMENT_ADD_GET_IMAGE_PO_PREVIEW_FAILURE =
    'CONSIGNMENT_ADD: GET_IMAGE_PO_PREVIEW_FAILURE';
export const STORE_CONSIGNMENT_ADD_REFERENCE =
    'CONSIGNMENT_ADD: STORE_CONSIGNMENT_ADD_REFERENCE';
export const RESET_PRICES_FOR_ITEMS = 'CONSIGNMENT_ADD: RESET_PRICES_FOR_ITEMS';
export const RESET_CONSIGNMENT_ADD_REFERENCE =
    'CONSIGNMENT_ADD: RESET_CONSIGNMENT_ADD_REFERENCE';
export const INITIAL_CONSIGNMENT_ADD_DATA =
    'CONSIGNMENT_ADD: INITIAL_CONSIGNMENT_ADD_DATA';
export const SET_ORDER_FROM_REPORT_USAGE =
    'CONSIGNMENT_ADD: SET_ORDER_FROM_REPORT_USAGE';
export const CONSIGNMENT_ADD_ORDER_FROM_USAGE_DETAILS =
    'CONSIGNMENT_ADD_ORDER_FROM_USAGE_DETAILS';

export const GET_DROPDOWN_OPTIONS = 'CONSIGNMENT_ADD: GET_DROPDOWN_OPTIONS';
export const GET_DROPDOWN_OPTIONS_SUCCESS =
    'CONSIGNMENT_ADD: GET_DROPDOWN_OPTIONS_SUCCESS';
export const GET_DROPDOWN_OPTIONS_FAILURE =
    'CONSIGNMENT_ADD: GET_DROPDOWN_OPTIONS_FAILURE';
export const SET_CONSIGNMENT_ADD_CU_IN_PROGRESS =
    'CONSIGNMENT_ADD:SET_CONSIGNMENT_ADD_CU_IN_PROGRESS';

export const SET_CONSIGNMENT_ADD_ORDER_SUBMITTED =
    'CONSIGNMENT_ADD: SET_CONSIGNMENT_ADD_ORDER_SUBMITTED';
export const RESET_CREATECONSIGNMENT_ADD =
    'CONSIGNMENT_ADD: RESET_CREATE_CONSIGNMENT_ADD';
export const RESET_DERIVED_TERRITORIES =
    'CONSIGNMENT_ADD: RESET_DERIVED_TERRITORIES';
export const STORE_SELECTED_PRODUCTS_DATA =
    'CONSIGNMENT_ADD: STORE_SELECTED_PRODUCTS_DATA';
export const RESET_STORE_ITEM_TABLE_DATA =
    'CONSIGNMENT_ADD: RESET_STORE_ITEM_TABLE_DATA';

export const SET_PRODUCT_TEMPLATE_UID =
    'CONSIGNMENT_ADD: SET_PRODUCT_TEMPLATE_UID';

export const GET_PRODUCT_BUNDLE = 'CONSIGNMENT_ADD: GET_PRODUCT_BUNDLE';
export const GET_PRODUCT_BUNDLE_SUCCESS =
    'CONSIGNMENT_ADD: GET_PRODUCT_BUNDLE_SUCCESS';
export const GET_PRODUCT_BUNDLE_FAILURE =
    'CONSIGNMENT_ADD: GET_PRODUCT_BUNDLE_FAILURE';
export const GET_TRANSFER_RECIPIENT_METHODS = 'ADD: GET_TRANSFER_RECIPIENT_METHODS';
export const GET_TRANSFER_RECIPIENT_METHODS_SUCCESS = 'ADD: GET_TRANSFER_RECIPIENT_METHODS_SUCCESS';
export const GET_TRANSFER_RECIPIENT_METHODS_FAILURE = 'ADD: GET_TRANSFER_RECIPIENT_METHODS_FAILURE';
export const CLEAR_TRANSFER_RECIPIENTS = 'ADD: CLEAR_TRANSFER_RECIPIENTS';
    